import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { Tooltip as TooltipPrimitive } from 'radix-ui';

function TooltipProvider({
  delayDuration = 300,
  ...props
}: Readonly<React.ComponentProps<typeof TooltipPrimitive.Provider>>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip({
  ...props
}: Readonly<React.ComponentProps<typeof TooltipPrimitive.Root>>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  );
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

function TooltipContent({
  className,
  sideOffset = 0,
  children,
  arrow = true,
  container,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content> & {
  arrow?: boolean;
  container?: React.ComponentProps<typeof TooltipPrimitive.Portal>['container'];
}) {
  return (
    <TooltipPrimitive.Portal container={container}>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'z-tooltip flex max-w-72 rounded-sm border-none bg-ui-inverse01 p-2 text-[14px] leading-4 font-normal text-ellipsis text-text-inverse shadow-[0px_2px_4px_0px_rgba(9,30,66,0.16)] drop-shadow-[0px_0px_1px_0px_rgba(9,30,66,0.24)]',
          className,
        )}
        {...props}
      >
        {children}
        {arrow && (
          <TooltipPrimitive.Arrow className="h-2 w-3 fill-ui-inverse01" />
        )}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
